module.exports = __webpack_public_path__ + "img/employee_benefits_hero_mobile.82089732.jpg";